<template lang="pug" src="./footer-main.pug"></template>

<script>
import Icon from '../icon/icon'
import FooterModal from '../modal/footer/modal-footer'

export default {
  props: [],
  data: () => {
    return {
      props: {
        menu: {}
      },
      showModal: false
    }
  },
  components: {
    Icon,
    FooterModal
  }
}
</script>



// WEBPACK FOOTER //
// footer-main.vue?385c4b00